import { TFunction } from 'i18next';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import getRelatedDateString from '_utils/getRelatedDateString';
import { capitalizeFirstLetter } from '_utils/misc';
import { smallestMargin } from '_utils/sizes';
import { useThemeContext } from '_utils/themeContext';
import { HeimeText, Icon } from 'Components';
import { BookingSharingAvailability, BookingSharingRequest } from 'types/BookingSharing';

const BookingSharingDetails = ({
    content,
    end_at,
    start_at,
}: Pick<BookingSharingRequest | BookingSharingAvailability, 'content' | 'start_at' | 'end_at'>) => {
    const { t } = useTranslation();
    const { theme } = useThemeContext();

    return (
        <>
            {content ? <HeimeText variant="subtitle">{content}</HeimeText> : null}
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: smallestMargin }}>
                <Icon name="note" color="main" />
                <HeimeText style={{ color: theme.main }} variant="subtitle">
                    {getStartString(new Date(start_at), t)}
                </HeimeText>
            </View>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: smallestMargin }}>
                <Icon name="arrow" color="main" />
                <HeimeText style={{ color: theme.main }} variant="subtitle">
                    {t('bookingSharing:until')} {getEndString(new Date(end_at))}
                </HeimeText>
            </View>
        </>
    );
};

const getStartString = (from: Date, t: TFunction) => {
    const [startString] = getRelatedDateString(from);
    if (moment(from).isSame(moment(), 'day')) {
        return capitalizeFirstLetter(`${t('reservations:today')} ${startString}`);
    }
    return startString;
};

const getEndString = (to: Date) => {
    const [endString] = getRelatedDateString(to);
    return endString;
};

export default BookingSharingDetails;
